import { Tag, TagProps } from '@chakra-ui/react';

type ActiveTagProps = TagProps & {
  isActive: boolean
}

export default function ActiveTag({ isActive, ...props }: ActiveTagProps) {
  const [color, text] = isActive ? ['green', 'Ativo'] : ['gray', 'Inativo'];
  return (
    <Tag 
      colorScheme={color}
      {...props}
    >
      {text}
    </Tag>
  )
}
